const phoneSupportUSA = "+1 (937) 745-2716";
const phoneSupportGB = "+4 (420) 453-84186";

type Legal = {
  company: string;
  address: string;
  law: string;
  law2: string;
  law3: string;
  registrationNumber: string;
  addressUnit: string;
};

const legalMma: Legal = {
  company: "MMA Digital Corp",
  address: "7251 West Lake Mead Boulevard, Suite 300, Las Vegas, NV, 89128",
  law: "the state Nevada",
  law2: "the US",
  law3: "US",
  registrationNumber: "2491277",
  addressUnit: "a business address",
};

// const legalSleekwell: Legal = {
//   company: "Sleekwell Corp",
//   address:
//     "The Gramercy, Center #3037, 9205 W. Russell Rd. Suite 240, Las Vegas, NV 89148",
//   law: "the state Nevada",
//   law2: "the US",
//   law3: "US",
//   registrationNumber: "10002228",
//   addressUnit: "a business address",
// };

const legalPrimula: Legal = {
  company: "Primula Capital LTD",
  address:
    "Agias Zonis, 23, Kotsios Court A, Flat/Office 51, 3027, Limassol, Cyprus",
  law: "England and Wales",
  law2: "the UK",
  law3: "UK",
  registrationNumber: "HE 413956",
  addressUnit: "a business address",
};

const legalDragalinos: Legal = {
  company: "Dragalinos Limited",
  address: "5-9 Main Street, GX1 11AA, Gibraltar",
  law: "the Gibraltar",
  law2: "the UK",
  law3: "UK",
  registrationNumber: "2491277",
  addressUnit: "a business address",
};

const legalList: Record<string, Legal> = {
  USA: legalMma,
  CAN: legalMma,
  EUR: legalPrimula,

  // All other countries.
  "": legalDragalinos,
};

function getByCountryCode(countryAlpha3: string): Legal {
  if (euCountriesAlpha3.includes(countryAlpha3)) {
    countryAlpha3 = "EUR";
  }

  return legalList[countryAlpha3] ?? legalList[""];
}

export function replaceLegalVariables(
  text: string,
  {
    countryAlpha3,
    baseUrl = "/text-page/",
    projectName = "MeetMyAge",
    projectHost = "meetmyage.com",
  }: {
    countryAlpha3: string;
    baseUrl?: string;
    projectName?: string;
    projectHost?: string;
  },
) {
  return text
    .replace(/{{project}}/g, projectName)
    .replace(/{{host}}/g, projectHost)
    .replace(/{{baseUrl}}/g, baseUrl)
    .replace(/{{company}}/g, getByCountryCode(countryAlpha3).company)
    .replace(/{{address}}/g, getByCountryCode(countryAlpha3).address)
    .replace(/{{law}}/g, getByCountryCode(countryAlpha3).law)
    .replace(/{{law2}}/g, getByCountryCode(countryAlpha3).law2)
    .replace(/{{law3}}/g, getByCountryCode(countryAlpha3).law3)
    .replace(
      /{{registrationNumber}}/g,
      getByCountryCode(countryAlpha3).registrationNumber,
    )
    .replace(/{{addressUnit}}/g, getByCountryCode(countryAlpha3).addressUnit)
    .replace(/{{phoneSupportUSA}}/g, phoneSupportUSA)
    .replace(/{{phoneSupportGB}}/g, phoneSupportGB);
}

const euCountriesAlpha3 = [
  "ALB", // Albania
  "AND", // Andorra
  "ARM", // Armenia
  "AUT", // Austria
  "AZE", // Azerbaijan
  "BEL", // Belgium
  "BGR", // Bulgaria
  "BIH", // Bosnia and Herzegovina
  "CHE", // Switzerland
  "CYP", // Cyprus
  "CZE", // Czech Republic
  "DEU", // Germany
  "DNK", // Denmark
  "ESP", // Spain
  "EST", // Estonia
  "FIN", // Finland
  "FRA", // France
  "FRO", // Faroe Islands
  "GBR", // United Kingdom
  "GEO", // Georgia
  "GRC", // Greece
  "GRL", // Greenland
  "HRV", // Croatia
  "HUN", // Hungary
  "IMN", // Isle of Man
  "IRL", // Ireland
  "ISL", // Iceland
  "ITA", // Italy
  "LIE", // Liechtenstein
  "LTU", // Lithuania
  "LUX", // Luxembourg
  "LVA", // Latvia
  "MCO", // Monaco
  "MDA", // Moldova
  "MKD", // North Macedonia
  "MLT", // Malta
  "MNE", // Montenegro
  "NLD", // Netherlands
  "NOR", // Norway
  "POL", // Poland
  "PRT", // Portugal
  "ROU", // Romania
  "SMR", // San Marino
  "SRB", // Serbia
  "SVK", // Slovakia
  "SVN", // Slovenia
  "SWE", // Sweden
  "UKR", // Ukraine
  "VAT", // Vatican City (Holy See)
];
